import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17 4V20M17 20L13 16M17 20L21 16M7 20V4M7 4L3 8M7 4L11 8",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSortIcon;
